<template>
  <v-footer
    color="#1e293b"
    class="modern-footer white--text"
    padless
  >
    <v-container class="footer-container">
      <v-row class="footer-content">
        <!-- Company Info -->
        <v-col cols="12" lg="5" class="company-section">
          <div class="company-info">
            <v-img
              :src="require('@/assets/img/logo.png')"
              alt="AutoSync Logo"
              max-height="50"
              max-width="180"
              contain
              class="footer-logo mb-4"
            ></v-img>
            <p class="company-description">
              Your trusted partner in finding the perfect vehicle. We provide premium quality vehicles
              with exceptional service and competitive pricing.
            </p>
            <div class="social-links mt-4">
              <!-- Add social media icons here if needed -->
            </div>
          </div>
        </v-col>

        <!-- Quick Links -->
        <v-col cols="12" md="6" lg="3" class="links-section">
          <h6 class="footer-title mb-4">Quick Links</h6>
          <div class="footer-links">
            <a href="/inventory" class="footer-link" @click.prevent="$router.push('/inventory')">
              Vehicle Inventory
            </a>
            <a href="/login" class="footer-link" @click.prevent="$router.push('/login')">
              Sign In
            </a>
            <a href="/signup" class="footer-link" @click.prevent="$router.push('/signup')">
              Create Account
            </a>
          </div>
        </v-col>

        <!-- Contact Info -->
        <v-col cols="12" md="6" lg="4" class="contact-section">
          <h6 class="footer-title mb-4">Get In Touch</h6>
          <div class="contact-info">
            <div class="contact-item">
              <v-icon color="white" class="contact-icon material-icons-round">phone</v-icon>
              <span class="contact-text">Call us for inquiries</span>
            </div>
            <div class="contact-item">
              <v-icon color="white" class="contact-icon material-icons-round">email</v-icon>
              <span class="contact-text">Email us anytime</span>
            </div>
            <div class="contact-item">
              <v-icon color="white" class="contact-icon material-icons-round">location_on</v-icon>
              <span class="contact-text">Visit our showroom</span>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Copyright -->
      <v-divider class="footer-divider"></v-divider>
      <div class="copyright-section">
        <p class="copyright-text">
          © {{ new Date().getFullYear() }} AutoSyncX™. All rights reserved.
          <span class="powered-by">Powered by innovation.</span>
        </p>
      </div>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'PublicFooter'
}
</script>

<style scoped>
/* Modern Footer */
.modern-footer {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%) !important;
  margin-top: 0;
}

.footer-container {
  max-width: 1400px;
  padding: 60px 24px 0;
}

.footer-content {
  padding-bottom: 40px;
}

/* Company Section */
.company-section {
  margin-bottom: 40px;
}

.company-info {
  max-width: 400px;
}

.footer-logo {
  filter: brightness(0) invert(1);
  transition: transform 0.3s ease;
}

.footer-logo:hover {
  transform: scale(1.05);
}

.company-description {
  font-size: 1rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
}

/* Links Section */
.links-section {
  margin-bottom: 40px;
}

.footer-title {
  font-size: 1.25rem !important;
  font-weight: 700 !important;
  color: white !important;
  margin-bottom: 20px;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-link {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.3s ease;
  padding: 8px 0;
  border-bottom: 1px solid transparent;
}

.footer-link:hover {
  color: #60a5fa;
  border-bottom-color: #60a5fa;
  transform: translateX(4px);
}

/* Contact Section */
.contact-section {
  margin-bottom: 40px;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.contact-icon {
  font-size: 20px !important;
  color: #60a5fa !important;
}

.contact-text {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
}

/* Copyright Section */
.footer-divider {
  background-color: rgba(255, 255, 255, 0.1) !important;
  margin: 0 -24px;
}

.copyright-section {
  padding: 30px 0;
  text-align: center;
}

.copyright-text {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  line-height: 1.5;
}

.powered-by {
  color: #60a5fa;
  font-weight: 600;
}

/* Responsive Design */
@media (max-width: 1264px) {
  .footer-container {
    padding: 50px 20px 0;
  }
}

@media (max-width: 960px) {
  .footer-container {
    padding: 40px 16px 0;
  }

  .company-section,
  .links-section,
  .contact-section {
    margin-bottom: 30px;
  }

  .footer-content {
    padding-bottom: 30px;
  }
}

@media (max-width: 600px) {
  .footer-container {
    padding: 30px 12px 0;
  }

  .footer-title {
    font-size: 1.125rem !important;
  }

  .company-description {
    font-size: 0.9rem;
  }

  .footer-link {
    font-size: 0.9rem;
  }

  .contact-text {
    font-size: 0.9rem;
  }

  .copyright-text {
    font-size: 0.8rem;
  }
}
</style>
